<template>
    <portal to="modal" v-if="open">
        <u-modal class="flex flex-col items-center">
            <h1 class="mb-2 flex items-center text-xl font-heading font-medium leading-none">
                <span class="fa far fa-shopping-basket text-green-500 fa-sm mr-2"></span>
                <span class="text-blue-900">Added to Basket</span>
            </h1>

            <p class="max-w-3xl leading-normal font-light text-blue-900 mb-4">
                A sample of
                <strong v-text="item.brick.display_name"></strong>
                <span v-if="variation" class="inline-flex items-baseline text-gray-600 text-md">
                    <span>(<strong>H</strong>{{ variation.height }}<span class="text-sm">mm</span></span>
                    <span class="fal fa-times fa-fw fa-xs mx-px"></span>
                    <span><strong>L</strong>{{ variation.length }}<span class="text-sm">mm</span></span>
                    <span class="fal fa-times fa-fw fa-xs mx-px"></span>
                    <span><strong>D</strong>{{ variation.depth }}<span class="text-sm">mm</span>)</span>
                </span>
                has been added to your basket.
            </p>

            <div class="flex items-center justify-end">
                <a @click.prevent="open = false" href="#" class="block px-4 py-2 text-white bg-orange-400 hover:bg-orange-500 hover:text-white rounded-full mr-2">Continue Shopping</a>
                <a :href="basketUrl" class="block px-4 py-2 text-white bg-green-500 hover:bg-green-600 hover:text-white rounded-full">View Basket</a>
            </div>
        </u-modal>
    </portal>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },

        basketUrl: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            open: true,
        };
    },

    computed: {
        variation() {
            if (! this.item.extra || ! this.item.extra.variation) {
                return null;
            }

            let height, length, depth;

            [ height, length, depth ] = this.item.extra.variation.split('x');

            return { height, length, depth };
        },
    },
};
</script>